import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";

// Pretty referral URL (crashready.com/r/CODE) → server-side dynamic redirect,
// which logs the click (with UTM) and forwards to the current destination.
export default function RedirectCode() {
  const { code } = useParams();
  const [params] = useSearchParams();
  useEffect(() => {
    const qs = params.toString();
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/r/${encodeURIComponent(code)}${qs ? `?${qs}` : ""}`;
    window.location.replace(url);
  }, [code, params]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-navy text-white">
      <p className="text-sm">Redirecting…</p>
    </div>
  );
}
